export enum CommentAuthorType {
  Member = 'Member',
  Admin = 'Admin',
  AI = 'AI',
  System = 'System'
}

export class SupportMessage {
  supportCommentId !: string;
  message !: string;
  createdOn !: string;
  authorType !: CommentAuthorType;
  authorLabel !: string;
}
